export const GUARDS = {
  HAS_SELECTED_ADDRESS: 'HAS_SELECTED_ADDRESS',
  HAS_SELECTED_SHIPPING_METHOD: 'HAS_SELECTED_SHIPPING_METHOD',
};
export const GUARDS_FUNCTIONS = {
  [GUARDS.HAS_SELECTED_ADDRESS]: ({ context }) => {
    return context.address != null;
  },
  [GUARDS.HAS_SELECTED_SHIPPING_METHOD]: ({ context }) => {
    return context.shippingMethod != null;
  },
};
